<template>
  <div>
    <!-- <div ref="myEchart" style="height: 900px"></div> -->

    <img src="../assets/home(1).jpg" style="width: 100%" />
    <!-- <img src="../assets/e1.png" style="width: 30%" />
        <img src="../assets/e2.png" style="width: 30%" />
        <img src="../assets/e3.png" style="width: 30%" /> -->

    <div style="margin-bottom:60px">
      <p class="text">
        <!-- The SedS&T database is a specialized platform created under the
        Deep-Time Digital Earth (DDE) program, which aims to provide a
        comprehensive and independent repository for Scientific Ocean Drilling
        chronostratigraphic data. It serves the scientific community by
        systematically aggregating age data from various Scientific Ocean
        Drilling (SOD) sources, ensuring that the information is aligned with a
        unified standard. -->
        <!-- The SedS&T database is a specialized platform designed to serve as an
        independent, one-stop repository for chronostratigraphic data from
        Scientific Ocean Drilling (SOD) programs. It supports the scientific
        community by systematically compiling age data from a wide range of SOD
        sources, ensuring alignment with the GTS2020 standard. -->
        The <strong>SedS&T database</strong> is a unified repository of chronostratigraphic
        data from Scientific Ocean Drilling programs. By consolidating fragmented
        datasets and standardizing them to the <strong>GTS2020 timescale</strong>, it offers reliable,
        accessible age–depth information for global geoscience community.

      </p>
      <!-- <p class="text">Here are the key aspects of the SedS&T database:</p>
      <p class="text">
        Consolidation of Data: It brings together chronostratigraphic data from
        multiple SOD repositories, which was previously scattered and perhaps
        difficult to access and compare.
      </p> -->

      <p class="text">
        <!--Key Features of the SedST Database: Data Consolidation: SedST integrates
        chronostratigraphic data from multiple SOD repositories—many of which
        were previously fragmented, difficult to access, or hard to compare.-->
        <strong>Highlights:</strong><br>
        36,183 age data entries from 181 expeditions and 1,300 drill holes<br>
        Age–depth models for 1,543 holes<br>
        Integration of previously excluded radiometric dating data

      </p>
      <!-- <p class="text">
        Standardization: By aligning disparate data with
        <span style="color: red; font-size: 20px">GTS 2020</span> , SedS&T
        ensures that the scientific community can use the data reliably and
        consistently.
      </p> -->
      <!--<p class="text">
        Standardization: By aligning all data with the GTS2020 framework, the
        database ensures consistency and reliability for geoscientists
        worldwide.
      </p>
      <p class="text">
        Extensive Coverage: The database contains 36,183 initial age data
        entries from 181 expeditions and 1,300 drill holes, and provides
        age–depth models for 1,543 holes.
      </p>-->
      <!-- <p class="text">
        Extensive Database Coverage:
        <span style="color: red; font-size: 20px"
          >The database contains 36,183 initial age data entries from 181
          expeditions across 1,300 holes, and provides age-depth models for
          1,543 holes.</span
        >
      </p> -->
      <!--<p class="text">
        Inclusion of Radiometric Dating Data: The database incorporates
        radiometric dating data that was not previously integrated into similar
        datasets.
      </p>-->
      <p class="text">
        <strong>Reference: </strong> Cai, Can, Chao Ma, Bin Hu, Jiajia Zhang, Xi Chen, Dangpeng Xi,
        Meinan Shi, Jun Meng, Xin Li, Tiantian Wang, He Huang, Yida Yang, James G.
        Ogg, Mingcai Hou, Xiumian Hu, and Chengshan Wang. 2025. "SedST: An Updated
        Chronological Database for Ocean Sediments." GSA Bulletin. <a href="https://doi.org/10.1130/B37957.1"
      >https://doi.org/10.1130/B37957.1</a>
      </p>
      <p class="text">
        <strong>License: </strong> CC BY-NC-SA 4.0
      </p>
      <!--<div class="note">-->
      <!--  This database is published under the Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) license.-->
      <!--</div>-->

    </div>
  </div>
</template>

<script>
// import * as echarts from 'echarts';
// import * as d3 from 'd3';
// const projection = d3.geoNaturalEarth1();
// import mapData from '@/utils/world.zh.json';
// import 'echarts-gl';
// import pointData from '@/utils/point.json';
// import { getHomeColor, getHomeName } from '@/utils/getLabel';
// echarts.registerMap('myworld', mapData);
export default {
  name: 'homeName',
  mounted() {
    // this.mychartMap = echarts.init(this.$refs.myEchart);
    // let series = [];
    // pointData.map((item) => {
    //   series.push({
    //     type: 'scatter3D',
    //     coordinateSystem: 'globe',
    //     symbolSize: 4,
    //     name: getHomeName(item),
    //     data: [[item.longitude, item.latitude]],
    //     itemStyle: {
    //       color: getHomeColor(item),
    //     },
    //   });
    // });
    // let option = {
    //   backgroundColor: '',
    //   // backgroundColor: 'gray',
    //   tooltip: {
    //     trigger: 'axis',
    //   },
    //   legend: {
    //     show: true,
    //     right: 50,
    //     width: 300,
    //     height: 200,
    //     textStyle: {
    //       fontSize: 15,
    //     },
    //   },
    //   globe: {
    //     // show: true,
    //     // globeRadius: 100,
    //     baseTexture: '/earth.jpg',
    //     heightTexture: '/earth.jpg',
    //     displacementScale: 0.04,
    //     shading: 'color',
    //     // environment: './starfield.jpg',
    //     realisticMaterial: {
    //       roughness: 0.9,
    //     },
    //     postEffect: {
    //       enable: true,
    //     },
    //     light: {
    //       main: {
    //         intensity: 1,
    //         shadow: true,
    //       },
    //       // ambientCubemap: {
    //       //   texture: './pisa.hdr',
    //       //   diffuseIntensity: 0.2,
    //       // },
    //     },
    //     viewControl: {
    //       zoomSensitivity: 0,
    //     },
    //   },
    //   // geo: {
    //   //   map: 'myworld',
    //   //   // roam: true,
    //   //   roam: true,
    //   //   zoom: 1.1,
    //   //   label: {
    //   //     emphasis: {
    //   //       show: false,
    //   //     },
    //   //   },
    //   //   projection: {
    //   //     project: (point) => projection(point),
    //   //     unproject: (point) => projection.invert(point),
    //   //   },
    //   //   // silent: true,
    //   //   itemStyle: {
    //   //     // areaColor: '#004981', //地图颜色
    //   //     areaColor: '#0d1a23',
    //   //     // areaColor: '#a9a9f6',
    //   //     // areaColor: "black",
    //   //     borderColor: '#0390c5',
    //   //     emphasis: {
    //   //       areaColor: '#0b1c2d',
    //   //     },
    //   //   },
    //   // },
    //   series: series,
    // };
    // if (option && typeof option === 'object') {
    //   this.mychartMap.setOption(option, true);
    //   console.log(this.mychartMap.getOption());
    // }
    // window.onresize = this.mychartMap.resize;
  },
};
</script>

<style>
.text {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 18px;
}

</style>
